import { acceptHMRUpdate, defineStore } from 'pinia';
import { useConsolidationService } from '@repo/core/services';
import { ConsolidationParameters } from '@repo/core/models';

export const useConsolidationStore = defineStore('consolidation', () => {
  const consolidationService = useConsolidationService();

  // actions
  const fetchConsolidations = () => {
    return consolidationService.get('?$expand=*');
  };
  const fetchConsolidationsByFilter = (parameters?: string) => {
    return consolidationService.get(parameters);
  };
  const hasConsolidations = () => {
    return consolidationService.exists();
  };
  const saveConsolidations = (data: ConsolidationParameters) => {
    return consolidationService.post(data);
  };
  const refreshOpeningBalances = (financialYearId: string) => {
    return consolidationService.refreshOpeningBalances(financialYearId);
  };
  const refreshLinkNumbers = (financialYearId: string) => {
    return consolidationService.refreshLinkNumbers(financialYearId);
  };
  const removeClients = (clientIds: string[]) => {
    return consolidationService.removeClients(clientIds);
  };

  const actions = {
    fetchConsolidations,
    fetchConsolidationsByFilter,
    hasConsolidations,
    saveConsolidations,
    refreshOpeningBalances,
    refreshLinkNumbers,
    removeClients
  };

  return { ...actions };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useConsolidationStore, import.meta.hot));
}
